import { cn } from '../../lib/utils'
import type { ConflictCell } from './conflict-view-model'

export function ConflictValueCell({
  cell,
  dim,
  selected,
  onSelect,
  ariaLabel
}: {
  cell: ConflictCell
  dim?: boolean
  selected?: boolean
  onSelect?: () => void
  ariaLabel?: string
}) {
  const removedWas = cell.kind === 'removed' ? cell.was : undefined
  const cls = cn(
    'min-w-0 self-center truncate rounded-sm px-1 py-0.5 text-left font-mono',
    selected
      ? 'bg-brand-soft font-medium text-brand'
      : cell.kind !== 'value'
        ? 'text-ink-3 italic'
        : dim
          ? 'text-ink-3'
          : 'text-ink',
    onSelect && !selected && 'cursor-pointer hover:bg-st-idle-bg/50'
  )
  const title = cell.kind === 'value' ? cell.text : undefined
  const content =
    cell.kind === 'removed' ? (
      // Removed on this side: show the base value it drops, crossed off.
      removedWas !== undefined ? (
        <span className="text-st-down line-through">{removedWas}</span>
      ) : (
        'removed'
      )
    ) : cell.kind === 'absent' ? (
      '—'
    ) : (
      cell.text
    )

  // A per-field cell carries an aria-label and is a real (keyboard-accessible)
  // button; whole-entity cells defer to the column-header button for a11y.
  if (ariaLabel && onSelect) {
    return (
      <button
        type="button"
        aria-label={ariaLabel}
        aria-pressed={selected}
        onClick={onSelect}
        className={cls}
        title={title}
      >
        {content}
      </button>
    )
  }
  return (
    <span onClick={onSelect || undefined} className={cls} title={title}>
      {content}
    </span>
  )
}
